import React from 'react';
import CategoriesField from './components/CategoriesField';
import SubCategoriesField from './components/SubCategoriesField';
import style from './CategorySubCategorySection.module.scss';

const CategorySubCategorySection: React.FC = () => {
	return (
		<div className={style.container}>
			<CategoriesField />
			<SubCategoriesField />
		</div>
	);
};

export default CategorySubCategorySection;
